import React, { useState, useRef, useEffect } from "react";
import RichTextEditor from "../../Frontend/genericComponents/uiElements/richTextEditor/RichTextEditor";
import { createMemory, deleteMemoryByRecordId } from "../../../services/iqApiV2";
import { Trash2, ChevronDown, ChevronUp } from "react-feather";
import "./AutoNurtureMemory.css";

const AutoNurtureEmailCard = ({
  email,
  user,
  handleAfterSave,
  handleAfterDelete,
}) => {
  const [saving, setSaving] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const snippetRef = useRef(null);
  const editorRef = useRef(null);
  const containerRef = useRef(null);

  // Detect overflowing text for Show More / Less
  useEffect(() => {
    if (snippetRef.current) {
      snippetRef.current.classList.add("expanded");
      const fullHeight = snippetRef.current.scrollHeight;
      snippetRef.current.classList.remove("expanded");
      const visibleHeight = snippetRef.current.clientHeight;
      setOverflowing(fullHeight > visibleHeight + 5);
    }
  }, [email.prompt]);

  const handleSave = async () => {
    const updatedPrompt =
      editorRef.current?.querySelector(".ProseMirror")?.innerHTML ||
      email.prompt ||
      "";

    const cleanText = updatedPrompt
      .replace(/<[^>]+>/g, "")
      .replace(/\s|&nbsp;/g, "")
      .trim();

    if (!cleanText) {
      console.warn("Email content cannot be empty.");
      return;
    }

    setSaving(true);
    try {
      const resp = await createMemory(
        updatedPrompt,
        user?.company_name,
        null,
        user?.id,
        "email_nurture"
      );

      if (resp?.status === 200) {
        handleAfterSave(email.id, updatedPrompt);
      }
    } catch (err) {
      console.error("Save failed:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    try {
      if (!email.id.includes("new") && !email.isDraft) {
        await deleteMemoryByRecordId(email.id);
      }
      handleAfterDelete(email.id);
    } catch (err) {
      console.error("Error deleting memory:", err);
    }
  };

  return (
    <div
      key={email.id}
      className={`anm-card ${email.isDraft ? "anm-draft-card" : ""}`}
      ref={containerRef}
    >
      {email.isDraft ? (
        <div className="anm-editor-box">
          <div
            className="anm-editor-container"
            ref={editorRef}
          >
            <RichTextEditor
              editable={true}
              content={email.prompt || ""}
              onChange={() => {}}
            />
          </div>
          <div className="anm-editor-actions">
            <button
              className="anm-save-btn"
              disabled={saving}
              onClick={handleSave}
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      ) : (
        <div className="anm-card-content">
          <div className="anm-card-text">
            <div
              ref={snippetRef}
              className={`anm-snippet ${expanded ? "expanded" : "collapsed"}`}
              dangerouslySetInnerHTML={{
                __html: email.prompt?.trim() || "<em>(empty email)</em>",
              }}
            />
            {email.isDraft && <span className="anm-draft-label">(Draft)</span>}
            {/* {email.created_at && (
              <p className="anm-date">
                {new Date(email.created_at).toLocaleDateString()}
              </p>
            )} */}
          </div>

          {/* <div className="anm-card-actions">
            <button
              className="anm-delete-btn"
              onClick={handleDelete}
            >
              Delete
            </button>

            {email.isDraft && (
              <button
                className="anm-save-btn"
                disabled={saving}
                onClick={handleSave}
              >
                {saving ? "Saving..." : "Save"}
              </button>
            )}

            {overflowing && (
              <button
                className="anm-toggle-btn"
                onClick={() => setExpanded((prev) => !prev)}
              >
                {expanded ? "Show less ▲" : "Show more ▼"}
              </button>
            )}
          </div> */}
                    <div className="anm-card-actions">
                    {overflowing && (
                        <button
                        className="anm-toggle-btn"
                        onClick={() => setExpanded((prev) => !prev)}
                        aria-label={expanded ? "Show less" : "Show more"}
                        >
                        {expanded ? <ChevronUp size={18} color="#606A74"/> : <ChevronDown color="#606A74" size={18} />}
                        </button>
                    )}

                    <button
                        className="anm-delete-btn"
                        onClick={handleDelete}
                        aria-label="Delete email"
                    >
                        <Trash2 size={18} />
                    </button>

                    {email.isDraft && (
                        <button
                        className="anm-save-btn"
                        disabled={saving}
                        onClick={handleSave}
                        >
                        {saving ? "Saving..." : "Save"}
                        </button>
                    )}
                    </div>


        </div>
      )}
    </div>
  );
};

export default AutoNurtureEmailCard;
